class StickyBar {
	constructor(el) {
		this.el = el;
		this.tabsContainer = el.querySelector('.sticky-bar__tabs');
		this.tabs = [];
		this.sections = [];

		this.init();
	}

	init() {
		// The editor preview renders its own placeholder markup.
		if (this.el.classList.contains('sticky-bar--preview')) {
			return;
		}

		// Manually added links are rendered server-side.
		const extraLinks = this.tabsContainer.querySelectorAll('.sticky-bar__tab--link').length;

		// Blocks opt into the table of contents by emitting data-toc-label,
		// injected server-side for blocks with "Show in sticky bar" enabled.
		const sections = document.querySelectorAll('[data-toc-label]');
		const fragment = document.createDocumentFragment();

		sections.forEach((section) => {
			const label = (section.dataset.tocLabel || '').trim();
			const target = section.id;

			if (!label || !target) {
				return;
			}

			const tab = document.createElement('button');
			tab.className = 'sticky-bar__tab';
			tab.textContent = label;
			tab.type = 'button';
			tab.setAttribute('data-target', target);

			tab.addEventListener('click', () => {
				section.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});

			fragment.appendChild(tab);
			this.tabs.push(tab);
			this.sections.push({ section, tab });
		});

		// Auto-generated section tabs come before the manual links.
		this.tabsContainer.prepend(fragment);

		if (!this.tabs.length) {
			if (!extraLinks) {
				this.el.classList.add('sticky-bar--empty');
			}
			return;
		}

		// Set first tab as active
		this.tabs[0].classList.add('is-active');

		// Set up IntersectionObserver
		this.setupObserver();
	}

	setupObserver() {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const match = this.sections.find((s) => s.section === entry.target);
					if (match) {
						this.setActiveTab(match.tab);
					}
				}
			});
		}, {
			rootMargin: '-20% 0px -60% 0px',
			threshold: 0,
		});

		this.sections.forEach(({ section }) => {
			observer.observe(section);
		});
	}

	setActiveTab(activeTab) {
		this.tabs.forEach((tab) => tab.classList.remove('is-active'));
		activeTab.classList.add('is-active');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.sticky-bar').forEach((el) => new StickyBar(el));
});
